// extracted by mini-css-extract-plugin
module.exports = {"addPost":"index_addPost_3er8N","label":"index_label_1ah9d","submit":"index_submit_nqv7f","editor":"index_editor_1FD9c"};